var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// (webpack)-merge/~/lodash/_Symbol.js
// module id = 58
// module chunks = 9